export type HelpEventName =
  | 'help_center_opened'
  | 'help_topic_viewed'
  | 'external_help_opened'
  | 'context_hint_shown'
  | 'context_hint_dismissed'
  | 'onboarding_started'
  | 'onboarding_skipped'
  | 'onboarding_completed'
  | 'onboarding_step_completed';

export interface HelpAnalyticsPayload {
  [key: string]: string | number | boolean | null | undefined;
}

const trackToConsole = (eventName: HelpEventName, payload?: HelpAnalyticsPayload) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.info('[help-analytics]', eventName, payload ?? {});
  }
};

export const trackHelpEvent = (eventName: HelpEventName, payload?: HelpAnalyticsPayload) => {
  trackToConsole(eventName, payload);

  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('help:analytics', {
        detail: { eventName, payload: payload ?? {} },
      })
    );
  }
};
